import React from "react";
import ReactECharts from "echarts-for-react";
import { groupSeriesXY } from "../../utils/echartsSeries.js";

function hexToRgb(hex) {
  const v = hex.replace("#", "");
  return [parseInt(v.slice(0, 2), 16), parseInt(v.slice(2, 4), 16), parseInt(v.slice(4, 6), 16)];
}
function mixWith(hex, target, t) {
  const [r, g, b] = hexToRgb(hex);
  const [tr, tg, tb] = hexToRgb(target);
  const mix = (a, c) => Math.round(a + (c - a) * t);
  return `#${[mix(r, tr), mix(g, tg), mix(b, tb)].map((v) => v.toString(16).padStart(2, "0")).join("")}`;
}

export default function AleaChart({ data, color = "#3182bd", title }) {
  const groups = groupSeriesXY(data, { xKey: "YearGroup", groupKey: "stat", valueKey: "val" });

  // Min = version claire, Moy = couleur de base, Max = version foncée
  const palStat = {
    Min: mixWith(color, "#ffffff", 0.55),
    Moy: color,
    Max: mixWith(color, "#000000", 0.35),
  };

  const series = groups.map(({ group, points }) => ({
    name: group,
    type: "line",
    symbol: "circle",
    smoothed: true,
    symbolSize: 6,
    lineStyle: { width: 2, color: palStat[group] || "#888" },
    itemStyle: { color: palStat[group] || "#888" },
    data: points.map((p) => [p.x, p.y]),
  }));

  const option = {
    title: title ? { text: title, left: "center", textStyle: { fontSize: 13 } } : undefined,
    
    legend: { bottom: 0, itemWidth: 14, itemHeight: 10, textStyle: { fontSize: 15 } },
    grid: { left: 45, right: 15, top: title ? 40 : 20, bottom: 40, containLabel: true },
    xAxis: { type: "value", name: "Horizon", min: 2020, max: 2050, interval: 15, axisLabel: { fontSize: 14, formatter: (v) => String(v) }  },
    yAxis: { type: "value", name: "Jours / an", nameLocation: "middle", nameGap: 35, nameTextStyle: { fontSize: 10 } },
    series,
  };

  return <ReactECharts option={option} style={{ height: 420 }} notMerge lazyUpdate />;
}